import assert from '@/sui/tools/assert'

function hideValue (value, context, percent) {
  const opt = context.chart.config.options.plugins.datalabels
  assert.notNull(opt)
  assert.isNumber(value)

  const treshold = percent ? opt.minPercent : opt.minValue
  return value < treshold
}

function computeSumInSingeDataset (value, context) {
  assert.notNull(value)
  assert.notNull(context)

  const data = context.dataset.data
  const li = context.chart.legend.legendItems
  let sum = 0
  for (let i = 0; i !== data.length; ++i) {
    const hidden = li.length > i && li[i].hidden
    if (!hidden) {
      sum += context.dataset.data[i]
    }
  }

  assert.isNumber(sum)
  return sum
}

function computeSumInMultipleDatasets (datasets, value, context) {
  assert.notNull(datasets)
  assert.isArray(datasets)
  assert.notNull(value)
  assert.notNull(context)

  const datasetsCount = datasets.length
  let sum = 0
  const li = context.chart.legend.legendItems
  for (let i = 0; i !== datasetsCount; ++i) {
    const dataset = datasets[i]
    const hidden = li.length > i && li[i].hidden
    if (!hidden) {
      sum += dataset.data[context.dataIndex]
    }
  }

  assert.isNumber(sum)
  return sum
}

function computePercentDisplay (value, context) {
  assert.notNull(context)
  if (value == null) {
    return null
  }

  if (hideValue(value, context)) {
    return null
  }

  const datasets = context.chart.data.datasets
  const sum = (datasets.length === 1)
    ? computeSumInSingeDataset(value, context)
    : computeSumInMultipleDatasets(datasets, value, context)

  const percentValue = 100 * value / sum
  if (hideValue(percentValue, context, true)) {
    return null
  }

  const p = percentValue.toFixed(1)
  return {
    value: value,
    percent: p
  }
}

export function numbers (value, context) {
  if (value == null || hideValue(value, context)) {
    return ''
  }
  return value.toFixed(0)
}

export function percent (value, context) {
  if (value == null || hideValue(value, context, true)) {
    return ''
  }

  return `${value.toFixed(1)}%`
}

export function percentIndicator (value, context) {
  if (value == null || hideValue(value, context, true)) {
    return ''
  }

  const count = context.dataset.counts[context.dataIndex]
  return `${value.toFixed(1)}% (${count})`
}

export function computedPercentWithValue (value, context) {
  const v = computePercentDisplay(value, context, true)
  if (v == null) {
    return ''
  }

  return `${v.value} (${v.percent}%)`
}

export function computedPercent (value, context) {
  const v = computePercentDisplay(value, context, true)
  if (v == null) {
    return ''
  }

  return `${v.percent}%`
}

export let dynamic = function (value, context) {
  const cfg = context.chart.config
  const formatter = cfg.options.formatter
  assert.notNull(formatter)
  assert.isFunction(formatter)

  return formatter(value, context)
}

dynamic.percent = {
  label: 'Valeur% - Valeurs comme pourcentages',
  formatter: percent
}

dynamic.numbers = {
  label: 'Valeur arrondie',
  formatter: numbers
}

dynamic.computedPercentWithValue = {
  label: 'Valeur (Pourcentage%)',
  formatter: computedPercentWithValue
}

dynamic.computedPercent = {
  label: 'Pourcentage%',
  formatter: computedPercent
}

dynamic.percentIndicator = {
  label: 'Pourcentage% (Effectif)',
  formatter: percentIndicator
}
